import { render, staticRenderFns } from "./tabFundNonCashDonation.vue?vue&type=template&id=0f32a23a&"
import script from "./tabFundNonCashDonation.vue?vue&type=script&lang=ts&"
export * from "./tabFundNonCashDonation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports